/**
 * File navigation.js.
 */

export function navigation() {
    window.addEventListener('scroll', () => {
        if (window.scrollY > 200) {
            document.body.classList.add('has-sticky-header');
            document.body.classList.remove('has-sticky-header-animate-out');
            document.body.classList.add('has-sticky-header-animate-in');
        } else {
            document.body.classList.remove('has-sticky-header-animate-in');
            document.body.classList.add('has-sticky-header-animate-out');
            document.body.classList.remove('has-sticky-header');
        }
    });

    document.querySelectorAll('.menu-btn').forEach((menu) => {
        menu.addEventListener('click', () => {
            document.body.classList.toggle('mobile-menu-open');
        });
    });

    document.querySelectorAll('.nav-mobile-container a').forEach((link) => {
        link.addEventListener('click', () => {
            document.body.classList.remove('mobile-menu-open');
        });
    });
}

export function activeMenuLink() {

    const linkHash = (href) => {
        if (href) {
            return href.split('#').length > 1 ? `#${href.split('#')[1].toLowerCase().trim()}` : '';
        }
        return '';
    };

    const updateActive = (currentHash = window.location.hash) => {
        document.querySelectorAll('.primary-nav').forEach(function (nav) {
            nav.querySelectorAll('a').forEach(function (a) {
                const href = a.href;
                if (href) {
                    const hash = linkHash(href);
                    if (hash) {
                        if (hash === currentHash) {
                            a.parentNode.classList.add('current-menu-item');
                        } else {
                            a.parentNode.classList.remove('current-menu-item');
                        }
                    }
                }
            });
        });
    };

    updateActive();
    document.querySelectorAll('.primary-nav').forEach(function (nav) {
        nav.querySelectorAll('a').forEach(function (a) {
            a.addEventListener('click', function(e) {
                const currentPageWithoutAnchor = (window.location.origin + window.location.pathname).replace(/\/$/, '');
                const linkWithoutAnchor = (new URL(a.href).origin + new URL(a.href).pathname).replace(/\/$/, '');
                if (currentPageWithoutAnchor === linkWithoutAnchor) {
                    e.preventDefault();
                    window.location.hash = linkHash(a.href);
                    updateActive();
                    document.querySelector('html, body').scroll({
                        top: document.querySelector(window.location.hash).offsetTop - 100,
                        behavior: 'smooth'
                    });
                }
            });
        });
    });

    document.addEventListener('hashchange', () => {
        if (window.location.hash) {
            updateActive();
            setTimeout(function () {
                document.querySelector('html, body').scroll({
                    top: document.querySelector(window.location.hash).offsetTop - 100,
                    behavior: 'smooth'
                });
            }, 500);
        }
    });
}